<template>
  <section class="table-listing basetbl">
    <div v-if="loadingPage">
      <slot name="loading-slot">
        <div class="card text-center">
          <div class="card-body text-center">
            <i class="fa fa-spinner fa-spin" style="font-size: 40px;" />
          </div>
          <h3>Loading...</h3>
        </div>
      </slot>
    </div>

    <div v-else-if="itemsList.length < 1">
      <slot name="empty-slot">
        <div class="card">
          <div class="card-body text-center">
            <div class="row justify-content-center">
              <div class="col-12 col-xl-10">
                <img
                  src="/img/illustrations/empty.svg"
                  alt=""
                  class="img-fluid"
                  style="max-width: 150px;"
                />

                <p class="text-muted mt-3 mb-0">
                  There are no items to list.
                </p>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </div>

    <div v-else>
      <div class="mb-4 nopadinr" >
        <b-table
          class="m-0 bg-white"
          :striped="striped"
          :head-variant="headVariant"
          :responsive="responsive"
          :bordered="bordered"
          :outlined="outlined"
          :small="small"
          :hover="hover"
          :fixed="fixed"
          :foot-clone="footClone"
          :items="itemsList"
          :sort-desc.sync="sortDescLive"
          :sort-by.sync="sortByLive"
          :fields="fields"
          custom-prop="any"
        >
          <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
          <template
            v-for="(_, name) in $scopedSlots"
            :slot="name"
            slot-scope="slotData"
          >
            <slot :name="name" v-bind="slotData" />
          </template>
        </b-table>
      </div>
      <nav class="row" v-if="showPaginationRow">
        <div class="col-12 col-sm-auto pb-2 order-2">
          <div class="py-2">Total Items: {{ options.totalRows }}</div>
        </div>
        <div class="col-12 col-sm-auto pb-2 ml-auto order-3">
          <div class="form-row">
            <div class="col">
              <label class="py-2 m-0">Per Page: </label>
            </div>
            <div class="col">
              <b-form-select
                v-model="perPageInput"
                type="number"
                min="1"
                max="1000"
                placeholder="10"
                :options="posPerPage"
              />
            </div>
            <div class="col-auto">
              <button
                class="btn btn-secondary"
                @click="perPageLive = parseInt(perPageInput)"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-auto pb-2 order-4">
          <div class="form-row">
            <div class="col">
              <label class="py-2 m-0">Go To: </label>
            </div>
            <div class="col">
              <b-form-input
                v-model="jumpToPage"
                type="number"
                min="1"
                placeholder=""
              />
            </div>
            <div class="col-auto">
              <button
                class="btn btn-secondary"
                @click="
                  pageLive = parseInt(jumpToPage);
                  jumpToPage = '';
                "
              >
                Go
              </button>
            </div>
          </div>
        </div>
        <div
          class="col-12 col-sm-auto d-flex align-items-center justify-content-center mr-2 pb-2 order-1 order-sm-6"
        >
          <b-pagination
            v-model="pageLive"
            class="mp-3"
            :total-rows="options.totalRows"
            :per-page="perPageLive"
            prev-text="Prev"
            next-text="Next"
          />
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
/*eslint no-self-assign: "off" */
export default {
  name: 'TableListing',
  props: {
    showPaginationRow: {
      type: Boolean,
      default: true
    },
    pagination: {
      required: true,
      default: {
        perPage: 10,
        page: 1,
        sortBy: '',
        sortDesc: ''
      }
    },
    options: {
      required: true,
      default: {
        totalRows: 0,
        loadedAll: false
      }
    },
    loadingPage: {
      type: [Boolean, Function],
      default: false
    },
    headVariant: {
      type: String,
      default: 'dark'
    },
    responsive: {
      type: [Boolean, Function],
      default: true
    },
    striped: {
      type: [Boolean, Function],
      default: true
    },
    small: {
      type: [Boolean, Function],
      default: false
    },
    fixed: {
      type: [Boolean, Function],
      default: true
    },
    hover: {
      type: [Boolean, Function],
      default: false
    },
    footClone: {
      type: [Boolean, Function],
      default: false
    },
    outlined: {
      type: [Boolean, Function],
      default: true
    },
    bordered: {
      type: [Boolean, Function],
      default: true
    },
    items: {
      required: true,
      type: [Array, Function]
    },
    fields: {
      required: true,
      type: [Array, Function]
    }
    // sortBy: {
    //   required: false,
    //   type: String,
    //   default: ''
    // },
    // sortDesc: {
    //   required: false,
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      perPageInputVal: 10,
      jumpToPage: '',
      posPerPage: [
        {
          value: 5,
          text: '5'
        },
        {
          value: 10,
          text: '10'
        },
        {
          value: 25,
          text: '25'
        },
        {
          value: 50,
          text: '50'
        },
        {
          value: 100,
          text: '100'
        },
        {
          value: 150,
          text: '150'
        },
        {
          value: 200,
          text: '200'
        },
        {
          value: 500,
          text: '500'
        },
        {
          value: 1000,
          text: '1000'
        }
      ]
    };
  },
  computed: {
    perPageInput: {
      get() {
        return this.perPageInputVal;
      },
      set(val) {
        this.perPageInputVal = val;
      }
    },
    itemsList: {
      get() {
        let itemsShown = this.items;
        if (this.optionsComputed.loadedAll) {
          return itemsShown.slice(
            (this.pagination.page - 1) * this.pagination.perPage,
            this.pagination.page * this.pagination.perPage
          );
        }

        return itemsShown;
      },
      set(val) {}
    },
    optionsComputed: {
      get() {
        let defaultVals = {
          totalRows: 0,
          loadedAll: false
        };
        let mainOpts = this.options;
        return { ...defaultVals, ...mainOpts };
      },
      set(val) {
        this.$emit('options-changed', val);
        this.$emit('update:options', val);
      }
    },
    paginationComputed: {
      get() {
        let defaultVals = {
          perPage: 10,
          page: 1,
          sortBy: '',
          sortDesc: false
        };
        let mainPags = this.pagination;
        let val = { ...defaultVals, ...mainPags };
        this.perPageInputVal = val.perPage;
        return val;
      },
      set(val) {
        this.$emit('update:pagination', val);
        setTimeout(() => {
          this.$emit('pagination-changed', val);
        }, 10);
      }
    },
    perPageLive: {
      get() {
        let defVal = 10;
        let mainVal = this.pagination.perPage;
        if (!mainVal) {
          mainVal = defVal;
        }
        return mainVal;
      },
      set(val) {
        this.$set(this.paginationComputed, 'perPage', val);
        this.paginationComputed = this.paginationComputed;
      }
    },
    pageLive: {
      get() {
        let defVal = 1;
        let mainVal = this.pagination.page;
        if (!mainVal) {
          mainVal = defVal;
        }
        return mainVal;
      },
      set(val) {
        this.$set(this.paginationComputed, 'page', val);
        this.paginationComputed = this.paginationComputed;
      }
    },
    sortByLive: {
      get() {
        let defaultSort = '';
        let shouldSort = this.paginationComputed.sortBy;
        return shouldSort;
      },
      set(val) {
        this.$emit('update:sortBy', val);
        this.$set(this.paginationComputed, 'sortBy', val);
        this.paginationComputed = this.paginationComputed;
      }
    },
    sortDescLive: {
      get() {
        let shouldSort = this.paginationComputed.sortDesc;
        return shouldSort;
      },
      set(val) {
        this.$emit('update:sortDesc', val);
        this.$set(this.paginationComputed, 'sortDesc', val);
        this.paginationComputed = this.paginationComputed;
      }
    }
  }
};
</script>
